export const blockIconsAndroidBatteryFullAltNew = (
	<span className='material-symbols-outlined'>battery_full_alt</span>
);
